export enum ETipoOperacao {
  AQUISICAO = 1,
  ARREMATACAO = 2,
  VENDA_DIRETA_PRIMEIRO_ADQUIRENTE = 3,
  REPASSE_PARCEIRO = 4,
  RECEITA_BRUTA_CALCULADA = 5,
  BALNEARIO = 6,
  VENDA_TERRITORIO_NACIONAL_EMPRESAS_COLIGADAS_OU_MESMO_GRUPO_ECONOMICO = 7,
  RECEITA_CALCULADA_EXPORTACOES = 8,
  RECEITA_BRUTA_TRIBUTOS_INCIDENTES = 9,
  SEM_OPERACAO = 10,
}

interface OperacaoInfo {
  nome: string;
  indice: number;
  label: string;
}

export const OperacaoDetalhe: { [key in ETipoOperacao]: OperacaoInfo } = {
  [ETipoOperacao.AQUISICAO]: {
    nome: 'AQUISICAO',
    indice: ETipoOperacao.AQUISICAO,
    label: 'Aquisição',
  },
  [ETipoOperacao.ARREMATACAO]: {
    nome: 'ARREMATACAO',
    indice: ETipoOperacao.ARREMATACAO,
    label: 'Arrematação',
  },
  [ETipoOperacao.VENDA_DIRETA_PRIMEIRO_ADQUIRENTE]: {
    nome: 'VENDA_DIRETA_PRIMEIRO_ADQUIRENTE',
    indice: ETipoOperacao.VENDA_DIRETA_PRIMEIRO_ADQUIRENTE,
    label: 'Venda direta ao Primeiro Adquirente',
  },
  [ETipoOperacao.REPASSE_PARCEIRO]: {
    nome: 'REPASSE_PARCEIRO',
    indice: ETipoOperacao.REPASSE_PARCEIRO,
    label: 'Repasse para parceiro ou membro da cadeia produtiva, ou cooperado ou mandatário.',
  },
  [ETipoOperacao.RECEITA_BRUTA_CALCULADA]: {
    nome: 'RECEITA_BRUTA_CALCULADA',
    indice: ETipoOperacao.RECEITA_BRUTA_CALCULADA,
    label: 'Receita Bruta Calculada',
  },
  [ETipoOperacao.BALNEARIO]: {
    nome: 'BALNEARIO',
    indice: ETipoOperacao.BALNEARIO,
    label: 'Balneário',
  },
  [ETipoOperacao.VENDA_TERRITORIO_NACIONAL_EMPRESAS_COLIGADAS_OU_MESMO_GRUPO_ECONOMICO]: {
    nome: 'Venda Território Nacional Empresas Coligadas ou Mesmo Grupo Econômico',
    indice: ETipoOperacao.VENDA_TERRITORIO_NACIONAL_EMPRESAS_COLIGADAS_OU_MESMO_GRUPO_ECONOMICO,
    label: 'Venda Território Nacional - Empresas coligadas ou mesmo grupo econômico',
  },
  [ETipoOperacao.RECEITA_CALCULADA_EXPORTACOES]: {
    nome: 'RECEITA_CALCULADA_EXPORTACOES',
    indice: ETipoOperacao.RECEITA_CALCULADA_EXPORTACOES,
    label: 'Receita Calculada (-) Exportações',
  },
  [ETipoOperacao.RECEITA_BRUTA_TRIBUTOS_INCIDENTES]: {
    nome: 'RECEITA_BRUTA_TRIBUTOS_INCIDENTES',
    indice: ETipoOperacao.RECEITA_BRUTA_TRIBUTOS_INCIDENTES,
    label: 'Receita Bruta de Vendas (-) Tributos Incidentes',
  },
  [ETipoOperacao.SEM_OPERACAO]: {
    nome: 'SEM_OPERACAO',
    indice: ETipoOperacao.SEM_OPERACAO,
    label: 'Sem Operação',
  },
};
